const DEFAULT_APP_BASE_PATH = "/";

export function normalizeAppBasePath(value = DEFAULT_APP_BASE_PATH) {
  const normalized = String(value || "").trim();

  if (
    !normalized.startsWith("/") ||
    normalized.startsWith("//") ||
    normalized.includes("\\") ||
    normalized.includes("?") ||
    normalized.includes("#") ||
    normalized.includes("://") ||
    normalized.split("/").includes("..")
  ) {
    throw new Error("REACT_APP_BASE_PATH must be an absolute URL path.");
  }

  const withoutTrailingSlash = normalized.replace(/\/+$/, "");
  return withoutTrailingSlash || "/";
}

export function appBasePathFromPublicUrl(value) {
  const publicUrl = String(value || "").trim();
  if (!publicUrl || publicUrl === "." || publicUrl === "./") return "/";

  if (/^[a-z][a-z\d+.-]*:\/\//i.test(publicUrl)) {
    return normalizeAppBasePath(new URL(publicUrl).pathname);
  }

  return normalizeAppBasePath(publicUrl);
}

export function resolveAppBasePath({
  configuredPath = "",
  publicUrl = "",
  environment = "",
} = {}) {
  if (String(configuredPath || "").trim()) {
    return normalizeAppBasePath(configuredPath);
  }

  if (environment === "production") {
    return appBasePathFromPublicUrl(publicUrl);
  }

  return DEFAULT_APP_BASE_PATH;
}

export function withAppBasePath(path, basePath = APP_BASE_PATH) {
  const normalizedBase = normalizeAppBasePath(basePath);
  const rawPath = String(path || "/").trim();
  const normalizedPath = rawPath.startsWith("/") ? rawPath : `/${rawPath}`;

  if (normalizedBase === "/") return normalizedPath;
  if (
    normalizedPath === normalizedBase ||
    normalizedPath.startsWith(`${normalizedBase}/`)
  ) {
    return normalizedPath;
  }
  if (normalizedPath === "/") return `${normalizedBase}/`;
  return `${normalizedBase}${normalizedPath}`;
}

export const APP_BASE_PATH = resolveAppBasePath({
  configuredPath: process.env.REACT_APP_BASE_PATH,
  publicUrl: process.env.PUBLIC_URL,
  environment: process.env.NODE_ENV,
});
